export const ChevronDownIcon = ({ color }) => {
  return (
    <path
      d="M11.6635 14.6193C11.5597 14.5808 11.4609 14.5148 11.3673 14.4213L6.873 9.92701C6.73467 9.78851 6.66384 9.61443 6.6605 9.40476C6.65734 9.19526 6.72817 9.01801 6.873 8.87301C7.018 8.72818 7.19367 8.65576 7.4 8.65576C7.60634 8.65576 7.782 8.72818 7.927 8.87301L12 12.9463L16.073 8.87301C16.2115 8.73468 16.3856 8.66385 16.5953 8.66051C16.8048 8.65735 16.982 8.72818 17.127 8.87301C17.2718 9.01801 17.3443 9.19368 17.3443 9.40001C17.3443 9.60635 17.2718 9.78201 17.127 9.92701L12.6328 14.4213C12.5391 14.5148 12.4403 14.5808 12.3365 14.6193C12.2327 14.6578 12.1205 14.677 12 14.677C11.8795 14.677 11.7673 14.6578 11.6635 14.6193Z"
      fill={color}
    />
  )
}
